module.exports = __webpack_public_path__ + "img/hpgl.fedb19ca.png";